import { Doughnut, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins

export default {
  extends: Doughnut,
  mixins: [reactiveProp],
  data: () => ({
    options: {
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        position: 'bottom',
        labels: {
          fontColor: '#000',
          fontSize: 11
        }
      },
      tooltips: {
        mode: 'index',
        intersect: false
      }
    }
  }),
  mounted () {
    this.renderChart(this.chartData, this.options)
  }
}

